export default {
  Images() {
    return [
      // done born
      {
        description:
          "John's parents were so happy to welcome him into the world",
        memoryDate: "1958-02-07T00:00:00",
        title: "John has come to the world",
        imageUrl: require("@/assets/images/demo/timelines/newborn-baby-parent-holding.png"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text:
              "Wow, look at baby John! Even then, he had that same sweet smile we all loved.",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 12,
                text:
                  "This was a beautiful moment. I remember it like it was yesterday.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "A day to remember! John was such a beautiful baby.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text:
                  "Jon was so sweet as a baby. He looked just like his dad.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "Hard to believe this little baby grew up to be the amazing person we all miss so much.",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 18,
                text:
                  "This was a beautiful moment. I remember it like it was yesterday.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "A day to remember! John was such a beautiful baby.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text:
                  "Jon was so sweet as a baby. He looked just like his dad.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "John was such a beautiful baby. You can already see the kindness in his eyes.",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "A day to remember! John was such a beautiful baby.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text:
                  "Jon was so sweet as a baby. He looked just like his dad.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "This picture brings back so many memories. Even as a baby, John was full of life.",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text:
                  "This was a beautiful moment. I remember it like it was yesterday.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "A day to remember! John was such a beautiful baby.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text:
                  "Jon was so sweet as a baby. He looked just like his dad.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "What a precious photo. Little John had so much ahead of him, and he made every moment count.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 14,
                text:
                  "This was a beautiful moment. I remember it like it was yesterday.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "John's spirit shines through in this picture, even as a baby. He brought so much joy to everyone.",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 9,
                text:
                  "This was a beautiful moment. I remember it like it was yesterday.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "A day to remember! John was such a beautiful baby.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "Look at how peaceful and full of love baby John looks here. He carried that same warmth with him all his life.",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text:
                  "Jon was so sweet as a baby. He looked just like his dad.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "Such a sweet reminder of how John started his journey. He touched so many lives along the way.",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text:
              "This photo is such a treasure. Baby John grew up to be someone truly special.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 26,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done learning to walk
      {
        description: "John took his first steps at 1 year old, and never looked back",
        memoryDate: "1953-11-01T00:00:00",
        title: "John's first steps",
        imageUrl: require("@/assets/images/demo/timelines/first-steps-1-min.png"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text: "Look at him go! His very first steps into the world. So proud of you, little John.",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 20,
                text: "He was always unstoppable, even as a baby!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "His determination started young. That never changed.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text: "Those first steps turned into miles of adventure. He lived life to the fullest.",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 17,
                text: "Absolutely, he didn't waste a single day.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "From these tiny steps to all the places he traveled...what a journey!",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "He inspired us all to explore more. Missing him so much.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Little John learning to walk! Such a wonderful memory to hold onto.",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "It's amazing to look back and see where it all started.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "This reminds me of how determined he always was.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "This little guy was so eager to take on the world, even back then.",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 18,
                text: "He never shied away from a challenge. Born to explore!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "You could tell he had big things ahead of him, even at this age.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "He left a lasting mark wherever he went. Forever missed.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Seeing him take those first steps... it's like he was ready to conquer life.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 24,
                text: "And he did just that. He was a real go-getter.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "This picture shows his fearless side, ready to run before he could even walk!",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 5,
                text: "This picture captures his essence so perfectly.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "He never lost that spirit. A true adventurer at heart.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Such a sweet moment! Those wobbly steps were just the beginning.",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "He was always pushing forward, one step at a time.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Those little steps were the first of many big ones. Look at him go!",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "Seeing him take his first steps is so heartwarming. He was a force from day one.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 24,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done first birthday
      {
        description: "John's first birthday was a day to remember",
        memoryDate: "1953-11-16T00:00:00",
        title: "John's first birthday",
        imageUrl: require("@/assets/images/demo/timelines/first-birthday-1-min.png"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text: "Look at that smile! Even at 1, you could tell he was full of joy.",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 19,
                text: "That smile never changed. He could light up any room.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "Absolutely! I'll always remember him laughing at family gatherings.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text: "Wow, baby John had so much energy! He must have been a handful!",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 21,
                text: "He was indeed! Remember the time he climbed the tree at Grandma's and got stuck?",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "Haha, yes! He was always the adventurous one.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "He didn't change much, did he? Always full of life and energy.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Such a cute little guy! Always bringing joy from day one.",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "He really had that effect on people. Everyone adored him.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "True, he was so kind and thoughtful. A rare soul.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "This picture is priceless! He already looks like a little entertainer!",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 20,
                text: "Spot on! He was always the life of the party.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "Exactly, he had a natural charm even as a kid.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "He could make anyone laugh. Miss him so much.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Seeing him at 1 just reminds me how fast life goes. Cherish every moment.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 17,
                text: "So true. Time flies, and memories are precious.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "He was always a happy child. This picture just captures his spirit perfectly.",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "His happiness was infectious. Always brightened up any day.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "Yes, I don't think I ever saw him upset for long.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Look at those big, bright eyes! Full of wonder and curiosity.",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "hat curiosity stayed with him throughout life.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "This brings back memories of the good old days. So much love in that tiny face.",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "I can see future John already in that little face. So full of life!",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 20,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done first bike ride
      {
        description: "John's dad was very passionate about bikes",
        memoryDate: "1953-05-01T00:00:00",
        title: "First bike ride with dad",
        imageUrl: require("@/assets/images/demo/timelines/bike-ride-1-min.png"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text:
              "I remember this moment so well! John was so determined to get it right. That determination stayed with him throughout his life",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 10,
                text:
                  "This was a beautiful moment. I remember it like it was yesterday.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text:
                  "A day to remember! John was so excited to learn how to ride a bike.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text:
                  "Jon was so excited to learn how to ride a bike. I remember that day like it was yesterday.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "Look at little John! Even learning to ride a bike, he had that fearless spirit we all admired.",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 13,
                text:
                  "This was a beautiful moment. I remember it like it was yesterday.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 21,
                text:
                  "A day to remember! John was so excited to learn how to ride a bike.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-01T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "This picture captures the essence of John-always pushing forward, always ready for a new challenge.",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 7,
                text:
                  "This was a beautiful moment. I remember it like it was yesterday.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 6,
                text:
                  "A day to remember! John was so excited to learn how to ride a bike.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-03-24T16:43:31.1606916Z",
              },
              {
                likes: 9,
                text:
                  "Jon was so excited to learn how to ride a bike. I remember that day like it was yesterday.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2023-01-01T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "I can still hear the laughter from that day! John's joy in learning something new was contagious.",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 14,
                text:
                  "This was a beautiful moment. I remember it like it was yesterday.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text:
                  "A day to remember! John was so excited to learn how to ride a bike.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-03-04T16:43:31.1606916Z",
              },
              {
                likes: 18,
                text:
                  "Jon was so excited to learn how to ride a bike. I remember that day like it was yesterday.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "Such a beautiful memory. Even back then, John wasn't afraid to fall and get right back up.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 12,
                text:
                  "This was a beautiful moment. I remember it like it was yesterday.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "This was just the start of John's many adventures. He approached life the same way-full of energy and courage.",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 4,
                text:
                  "This was a beautiful moment. I remember it like it was yesterday.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "You can see the determination in his eyes. John always faced everything head-on, even as a kid learning to ride.",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 18,
                text:
                  "This was a beautiful moment. I remember it like it was yesterday.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "Little did we know that same bravery and persistence would define John's whole life. Miss him so much.",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text:
              "Look at him go! Even back then, John was unstoppable. A reminder of how he embraced every moment.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
          {
            text:
              "Such a sweet memory of John's childhood. That first bike ride was the start of so many great things to come.",
            likes: 23,
            fullName: "James Anderson",
            imageUrl:
              "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-10-04T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 19,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done first day of school
      {
        description:
          "At age 7, John entered elementary school, where his curiosity for science began to flourish",
        memoryDate: "1959-09-01T00:00:00",
        title: "John's first day of school",
        // todo check image
        imageUrl: require("@/assets/images/demo/timelines/1st-school-day-min.png"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text:
              "John's first day at school-he looked so excited and ready to take on the world! That enthusiasm never left him.",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 21,
                text:
                  "I remember seeing him that morning-he couldn't wait to dive into learning!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "That enthusiasm carried him through everything he did, from school to his career.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text:
              "I remember this day so well. John was so brave and eager to learn, just like he was in everything he did.",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 24,
                text:
                  "Yes, he was always fearless when it came to new experiences, even as a little kid.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "John's eagerness to learn and grow was one of his most admirable traits.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text:
                  "He always saw challenges as opportunities. This picture really captures that side of him.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "Look at little John, all dressed up for his first day! He carried that same curiosity and kindness with him through life.",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "It's amazing how much of his character was already present from such a young age.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text:
                  "That same kindness touched so many lives. He never lost that part of himself",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "Such a sweet memory. John was always so full of wonder, and it shows even on his first day of school.",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 13,
                text:
                  "John had such a unique way of appreciating the little things in life, just like he did back then.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "His sense of wonder was contagious. He made life feel like an adventure.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text:
                  "He saw the world with eyes full of curiosity, and that never went away.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "What a special moment. John's excitement for learning never faded, and neither did his bright smile.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 5,
                text:
                  "John's positivity was one of his greatest strengths, and this picture shows exactly where it all began.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "This photo brings back so many memories. From day one, John was always ready for new adventures.",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 18,
                text:
                  "It's amazing how early you could see that drive in him. He always embraced life with open arms.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "John was never one to shy away from trying new things-his whole life was an adventure.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "John was fearless, even on his first day of school. He approached life with the same courage and joy.",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text:
                  "That bravery stayed with him throughout his life. He was never afraid to face something new.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "You can see the excitement in his eyes. Little did we know, that was just the beginning of his incredible journey",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "Hard to believe this was the start of so many achievements for John. He always faced new challenges with a smile.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 15,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done got a dog
      {
        description: "Bruno was John's first dog, a loyal companion who was by his side through thick and thin",
        memoryDate: "1959-10-01T00:00:00",
        title: "John got his first dog",
        imageUrl: require("@/assets/images/demo/timelines/dog-min.jpg"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text: "John and his first dog-what a perfect pair! They were inseparable from day one.",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 15,
                text: "That dog was his shadow! They went everywhere together",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "He used to bring him to every family gathering. Such a sweet duo.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text: "Look at these two! It's like they were meant to find each other.",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "John had such a soft spot for animals. He loved them deeply.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "He'd always talk about how his dog was his closest companion.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "That dog brought out his kind and caring side. Truly heartwarming.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John's first dog - always by his side. They were a package deal!",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "Wherever John went, his dog was never far behind.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "This picture captures the love they shared. It's beautiful.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "He was so happy with his first dog. They brought each other so much joy.",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 13,
                text: "You could see the happiness in his eyes whenever he was with his dog.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "That dog could make him smile, even on a tough day.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "Pets are family, and his dog was a huge part of his life.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "I remember when he first got this dog. They were instant best friends.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 17,
                text: "He would tell everyone stories about their adventures together.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "His first dog - his first true best friend. They were always together.",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 2,
                text: "I remember them playing in the yard for hours.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "They were like two peas in a pod. Always having fun.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "The best duo! John and his first dog shared a bond like no other.",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "That dog was his partner in crime. They did everything together!",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John and his dog had an unbreakable bond. You could see it in his smile..",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "Can't think of John without thinking of his first dog. They were a perfect match.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 25,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done grandsons
      {
        description: "John was so happy to spend time with his grandsons",
        memoryDate: "2017-03-11T00:00:00",
        title: "John with his grandsons",
        imageUrl: require("@/assets/images/demo/timelines/grandsons-min.jpg"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text: "John loved being a grandpa more than anything. Look at how happy he is with his grandsons!",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 5,
                text: "He was the best grandpa, always there with a story or a joke",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "They were his pride and joy. Always talking about them.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text: "These boys brought out the biggest smiles in him. Grandpa John was a natural.",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 18,
                text: "He'd always show us pictures of them and share their latest adventures.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "He loved teaching them things, especially out in the garden.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "You could see how much joy they brought him. He was so proud.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Seeing him with his grandsons, you just knew how much love he had for them.",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "Every time we talked, he'd have a new story about the boys.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "They adored him too. Always by his side when he was around.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Such precious memories. He was an incredible grandpa, always so patient and loving.",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 15,
                text: "He'd spend hours with them, teaching them all his little tricks.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "They looked up to him so much. He was their hero.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "Those boys will carry his legacy forward, for sure.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Nothing made him happier than being with his grandsons. They were his world.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 19,
                text: "He used to tell me how much he looked forward to watching them grow.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Look at him, surrounded by his grandsons. This is how I'll always remember him.",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 20,
                text: "They brought out the playful side in him. Always laughing and joking.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "He was so full of life whenever they were around.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John was the kind of grandpa everyone would want. So loving and involved.",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "He'd always make time for them, no matter how busy he was.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "This photo shows just how deeply he loved his family. His grandsons meant everything to him.",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "Grandpa John was always there with open arms and a big heart for his grandsons.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 20,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done train station in Berlin
      {
        description: "John and his wife loved to travel. This was taken at a train station in Berlin",
        memoryDate: "1974-11-01T00:00:00",
        title: "Berlin Train Station",
        imageUrl: require("@/assets/images/demo/timelines/train-station-min.jpg"),
        location: "Berlin",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text: "John and his wife always had such a sense of adventure. Berlin was just one of many journeys they took together!",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 18,
                text: "They were always traveling! They never missed a chance to explore.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "I remember him talking about that Berlin trip-it sounded amazing.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text: "Seeing them off to Berlin! They were so excited for this trip. Such beautiful memories.",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 8,
                text: "They both loved experiencing new cultures and meeting new people.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "I remember him telling us about all the little cafes they discovered.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "That trip meant so much to them. They talked about it for years!",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Look at these two lovebirds, setting off for Berlin! They were so full of life.",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "They looked so happy together, no matter where they were.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "Their love was an adventure in itself, always growing stronger.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Berlin bound! They loved traveling together and made memories everywhere they went.",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 16,
                text: "He would talk for hours about the amazing things they saw in Berlin.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "They truly appreciated each moment they spent exploring.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "It's amazing to see how much joy they found in every journey together.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "I remember when they took this trip! They were so thrilled about going to Berlin.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "He talked about Berlin like it was a second home after they returned.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John and his wife at the train station, setting out for another adventure. Their love was timeless.",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 23,
                text: "They were a true example of what love and partnership should be.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "They always found joy in the little things, like train rides together.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Nothing like seeing these two travel together. Berlin was the perfect destination for them!",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "Their love for each other and for life was so inspiring.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "I love this photo of them at the train station. Ready to take on Berlin together!",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "On their way to Berlin! They made every moment an adventure together.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 14,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done scuba diving
      {
        description: "John loved to scuba dive. He was always happiest when he was underwater.",
        memoryDate: "1976-07-13T00:00:00",
        title: "Scuba Diving",
        imageUrl: require("@/assets/images/demo/timelines/scuba-diving-min.jpg"),
        location: "Miami",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text: "John was always up for an adventure, and scuba diving was one of his favorites! Look at him, in his element.",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 19,
                text: "He loved the ocean so much. He'd talk about it like it was his second home.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "He always came back with the best underwater stories!",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text: "Seeing John underwater was like seeing him in his true form. He absolutely loved diving.",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 8,
                text: "Remember how he'd go on and on about the fish and coral he'd see?",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "He was like a fish himself! Completely at ease underwater.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "Scuba diving brought him so much joy and peace.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Diving was his passion! He always looked so alive when he was in the water.",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "I'll never forget how he'd light up talking about his latest dive.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "He was so knowledgeable too, always sharing fun facts about marine life.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "This was his happy place-beneath the waves, exploring the deep blue.",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 12,
                text: "He found magic underwater. You could see it in his eyes every time.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "I loved hearing his stories about the underwater world. They were incredible!",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "He inspired so many of us to try diving ourselves.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Look at him, fearless and free under the sea. This was John at his best.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 14,
                text: "He was so brave, always exploring places others would shy away from.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Nothing made him happier than a day spent scuba diving. He was a natural.",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 10,
                text: "He would plan entire vacations around dive spots. So dedicated!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "Every trip he took, he made sure there was a dive involved.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "This was more than a hobby for him - it was a way of life.",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "He was always the first one suited up and ready to dive.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John and his scuba gear were a match made in heaven. He was so at peace down there.",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "John loved the ocean like no one else I know. Scuba diving was his true calling.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 16,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done john and jane wedding
      {
        description:
          "John and his wife shared a love that was truly one of a kind. This photo captures the essence of their bond.",
        memoryDate: "1988-09-01T00:00:00",
        title: "John's and Jane's wedding",
        imageUrl: require("@/assets/images/demo/timelines/wedding-1-min.png"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text:
              "This photo captures the essence of their love. John was truly glowing, and you could see how happy he was.",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 17,
                text:
                  "That glow never faded. John was always at his best when he was with her",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "You could see how much he adored her, even from across the room. It was beautiful.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text:
              "I'll never forget this day! John and his wife made everyone feel the love in the room-it was magical!",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text:
                  "I remember the warmth in the air. You could tell how much they were loved by everyone there",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "It felt like the whole room was filled with joy because of the love they shared.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text:
                  "It was truly one of those weddings where you could feel the magic in every little moment.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "What a stunning wedding! John and his wife looked so in love, and their joy was infectious.",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "They looked like they were living in their own little world, and it was wonderful to witness.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text:
                  "That joy stayed with them long after the wedding. They were always so happy together.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "This picture brings back so many wonderful memories. John was at his happiest, surrounded by love.",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 14,
                text:
                  "I've never seen John as happy as he was on that day. It was truly his moment.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "His happiness was undeniable, and it was all because of the love he shared with his wife.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text:
                  "It was one of the most memorable days of his life, and I'm so glad I got to witness it.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "Look at those smiles! John and his wife were a perfect team, and their love story was one for the ages.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 18,
                text:
                  "Their love story was like something out of a fairy tale, and their wedding was the perfect chapter.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "Such a heartfelt moment! John put so much thought into every detail, and it showed on this special day.",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 8,
                text:
                  "He truly made the day unforgettable, not just for his wife, but for everyone there.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "He was so thoughtful, and you could see that in every part of their wedding.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "What a beautiful celebration of love! John's joy and warmth shone through in every moment.",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text:
                  "His love for his wife was obvious in everything he did that day. It was beautiful to see.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "This photo is a reminder of how love can bring people together. John and his wife were the perfect couple.",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "John was radiant on his wedding day. You could feel the love between him and his wife from miles away.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 19,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done first child
      {
        description: "John and Jane welcomed their first child, Adam, a beautiful baby boy.",
        memoryDate: "1989-05-05T00:00:00",
        title: "First Child Born - Adam",
        imageUrl: require("@/assets/images/demo/timelines/new-baby-1-min.png"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text: "John with baby Adam-such a proud new dad! His joy was unmistakable.",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 24,
                text: "He talked about Adam nonstop! Couldn't wait to show him off to everyone.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "You could see in his eyes how much he loved being a dad.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text: "The day Adam was born was the happiest day of John's life. He loved his little boy so much.",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 4,
                text: "I remember him telling everyone, ‘I have a son!' with the biggest smile.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "He was so attentive, always making sure Adam was cozy and happy.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "Adam had John wrapped around his finger from day one.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John's heart grew ten times bigger the day Adam arrived. Such a sweet father-son moment.",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "He was always talking about how much he looked forward to fatherhood.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "Seeing him with Adam, you knew he was going to be an amazing dad.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John and baby Adam-a bond that was instant and unbreakable.",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 6,
                text: "From the first moment, he was dedicated to being the best dad he could be.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "He was so gentle with him, always checking on his little one.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "Adam brought out a whole new side of John, one full of love and care.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Adam's arrival brought so much joy to John's life. He was beyond thrilled to be a dad.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 15,
                text: "John was already planning Adam's future from the day he was born.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John became a dad, and the world became a brighter place for him. Baby Adam was everything to him.",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 13,
                text: "It was beautiful to see how fatherhood transformed him.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "He took his role as a dad so seriously, always there for Adam.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "That smile says it all-John with his newborn son, Adam. A moment he cherished.",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "He told me once that holding Adam for the first time was life-changing.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John was over the moon when Adam was born. Being a dad was his dream come true.",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "I'll never forget the joy John felt when Adam was born. He was such a proud dad.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 22,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done hiking image only
      {
        description: "John loved hiking with his wife. They were always up for an adventure, no matter where it took them.",
        memoryDate: "1984-08-18T00:00:00",
        title: "Hiking with Jane",
        imageUrl: require("@/assets/images/demo/timelines/sunset-min.jpg"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text: "John and Jane, always up for a hike! They loved exploring nature side by side.",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 18,
                text: "They were unstoppable on the trails, always finding new places to explore.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "I remember John saying how much he loved the peace he found in nature.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text: "Look at them go! John and Jane were the ultimate hiking duo.",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "They always knew the best trails. I loved joining them whenever I could.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "They had such a great time on their adventures. Hiking was their happy place.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "John used to say that being outdoors with Jane was his idea of paradise.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John and Jane looked so at peace in nature. Hiking was their way of recharging together.",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "It was amazing how they always made time to be outdoors, rain or shine.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "Such a beautiful couple, connected with each other and the world around them.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Every mountain, every trail - they conquered them together.",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 21,
                text: "This picture captures them perfectly, so full of life and adventure.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "Nothing could stop them once they decided on a trail!",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "They inspired so many of us to get outside and explore too.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John and Jane's hiking trips were legendary! They found joy in every climb.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 17,
                text: "He loved telling stories about their hikes, especially the funny moments.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Such a beautiful moment of John and Jane on the trail. Nature brought out the best in them.",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 5,
                text: "I remember how they'd get up at sunrise just to get an early start.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "They never missed an opportunity to be out there, even on chilly days.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John and Jane always found the most breathtaking trails. Their love for nature was inspiring.",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "The memories they made on these trails are priceless.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Hiking wasn't just an activity for John and Jane; it was their way of bonding.",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "John and Jane, enjoying the journey as much as the destination. They truly loved hiking together.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 23,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done beach walk
      {
        description: "Sunset, sand, and smiles. John and his family enjoyed a peaceful walk along the beach, creating memories that would last a lifetime.",
        memoryDate: "1986-07-04T00:00:00",
        title: "Beach Walk",
        imageUrl: require("@/assets/images/demo/timelines/beach-walk-min.jpg"),
        location: "Hawaii",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text: "Such a beautiful moment-John, his wife, and their little ones, walking along the beach at sunset. Pure family bliss",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 8,
                text: "his picture shows the love they all shared so clearly.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "Nothing made him happier than being with his family, especially by the ocean.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text: "A perfect family moment. John and his family walking by the shore as the sun sets-such a warm memory.",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 18,
                text: "He always said sunsets were his favorite, especially with his family by his side.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "Those beach walks meant so much to him. He cherished every moment.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John's happiest times were spent with his family. This sunset beach walk was just one of many precious memories.",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "He loved showing his kids the beauty of nature and simple moments like these.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "They must have had the best time, soaking up that peaceful sunset together.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Walking with his family as the sun sets-John was right where he belonged.",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 14,
                text: "He was such a dedicated father and husband. Family was everything to him.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "The beach brought out his playful side; his kids loved it.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "They look like they're making memories that would last a lifetime.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "A perfect evening walk for a beautiful family. John, his wife, and kids look so happy here.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 10,
                text: "You could see how proud he was of his family whenever they were together.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John loved these simple moments-walking along the beach, hand in hand with his family.",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 17,
                text: "He often said that sunset beach walks were his favorite way to unwind.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "It was his happy place, especially with his family all around him.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "That sunset glow on John and his family-it's like they were meant to be there together.",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "He always talked about how peaceful these walks made him feel.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John loved the beach, especially with his wife and kids by his side. This sunset photo is unforgettable.",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "Walking into the sunset with his family. John couldn't have been happier.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 12,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done fishing
      {
        description: "John and his friend David went fishing",
        memoryDate: "1930-06-01T00:00:00",
        title: "Fishing",
        imageUrl: require("@/assets/images/demo/timelines/fishing-min.jpg"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text: "John and David loved their fishing trips-such great memories of them out on the water.",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 8,
                text: "They were fishing buddies through and through! Always competing for the biggest catch.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "ohn would tell the best fishing stories; they'd have everyone laughing.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text: "Nothing like a day of fishing with your best friend. John and David had the best times out there.",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 7,
                text: "They were so patient, just waiting for the perfect catch.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "John always said that being out on the water with David was his idea of a perfect day.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "He'd come back with such a glow after these trips.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John and David, rods in hand and smiles on their faces. Fishing was their happy place.",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "They had their favorite fishing spots. I swear they knew all the best places.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "John's patience was unmatched-he'd wait hours for just the right bite!",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Out on the lake with David, John was right where he wanted to be. They loved their fishing adventures.",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "Fishing with David was a tradition he looked forward to every year.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "You could tell they had a great time, rain or shine.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "They had so many great stories-remember the time they almost caught that huge bass?",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "These two were the ultimate fishing team! John and David always brought back a story or two.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 14,
                text: "John would always exaggerate just a little about the size of his catches!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Fishing wasn't just a hobby for John and David; it was their way of relaxing and bonding.",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 16,
                text: "John always said fishing taught him patience and gave him peace.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "David was like family to him. This picture captures it all.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Every fishing trip with David was an adventure. John was happiest out there, rod in hand.",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "I loved hearing about the ‘ones that got away' stories.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Just John, David, and the open water. Fishing was their way of catching up and making memories.",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "Out fishing with David was one of John's favorite things. They had some of the best times together.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 6,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done dog walk
      {
        description: "Their dog walk in the woods of Los Angeles",
        memoryDate: "1991-02-14T00:00:00",
        title: "John and Jane dog walk",
        imageUrl: require("@/assets/images/demo/timelines/dog-walk-min.jpg"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text: "John and Jane loved their dog walks in the woods. You could tell it was their favorite time together.",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 18,
                text: "Their dog always looked so happy by their side, especially in the woods!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "They were such a close-knit family, even including their furry friend in every adventure.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text: "John, Jane, and their loyal pup exploring the woods together-such a beautiful memory.",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 19,
                text: "Their dog loved being out there just as much as they did!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "Nothing could bring them more joy than a peaceful walk through the trees.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "Those walks were their little escape from the world.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John and Jane's walks in the woods were their happy place, and their dog loved every moment too.",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "They found the most beautiful trails, always full of laughter and love.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "Their dog was always right by their side, trotting along happily.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Just the three of them-the woods, the fresh air, and their pup. This was their idea of a perfect day.",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 3,
                text: "I remember how their dog would run ahead, then turn back to make sure they were following.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "John loved sharing these walks with Jane and their pup.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "It's like the woods were their second home.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "A peaceful family walk. John, Jane, and their dog always looked so happy together in the forest.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 14,
                text: "They'd spend hours out there, just enjoying the quiet and each other's company.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John and Jane loved these nature walks with their dog. Such sweet memories.",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 9,
                text: "John would always talk about how much he loved the peace of the woods.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "This picture captures their calm and happiness perfectly.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Seeing John and Jane with their dog on these walks was so heartwarming. A beautiful family moment.",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "It's wonderful how they made these walks part of their routine.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "These walks were their way of unwinding, just the three of them in the woods. So peaceful.",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "John, Jane, and their dog, exploring their favorite trail. It was their little piece of paradise.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 14,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done retirement
      {
        description: "John living his best life in retirement",
        memoryDate: "2017-03-27T00:00:00",
        title: "Retirement",
        imageUrl: require("@/assets/images/demo/timelines/retired-min.jpg"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text: "John enjoyed his retirement with quiet moments of rest, appreciating the simple joys of life.",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 7,
                text: "He deserved every peaceful moment; he gave so much to all of us",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "It's comforting to know he had time to reflect on his wonderful life.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text: "Those retirement years gave John the chance to rest and reflect-he truly earned it.",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 15,
                text: "He'd share such beautiful stories from his bed, always teaching us something new.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "Restful days gave him time to think back on all he accomplished.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "Even in rest, he was always so present and wise.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John spent his retirement in peace, resting comfortably and sharing his warmth with family and friends.",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "He still had that joyful spark, even while resting in bed.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "His stories became even richer; every moment with him was a blessing.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John took the time to rest in his retirement, reflecting on a lifetime of love and memories.",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 20,
                text: "It's beautiful that he could relax and enjoy the quiet moments.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "He spent his days peacefully, surrounded by those he loved.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "John had such a gentle presence, even in stillness.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "His retirement years brought him well-deserved rest. John could finally just relax and enjoy the calm.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "His restful spirit was inspiring; he knew how to make peace with every day.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John resting peacefully in his retirement was a fitting end to his hardworking life. He earned it.",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 17,
                text: "Seeing him content was such a comfort to everyone who loved him.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "His peaceful retirement was filled with love and gratitude.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "He spent his retirement resting, surrounded by memories, love, and family. John deserved that peace.",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "He taught us that rest is a form of self-love and reflection.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John's retirement years brought a sense of peace. He could rest and be surrounded by love.",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "Spending retirement in restful peace, John showed us the beauty of stillness and reflection.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 23,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done old in love
      {
        description: "Jane was always the one to make John laugh, even after all these years.",
        memoryDate: "2020-10-10T00:00:00",
        title: "John and Jane old and in love",
        imageUrl: require("@/assets/images/demo/timelines/old-in-love-min.jpg"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text: "John and Jane in the embrace of a lifetime. Their love only grew stronger over the years.",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 12,
                text: "You could feel the warmth between them, even in a simple hug.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "They were the perfect example of true love-always so connected.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text: "This picture captures decades of love, support, and shared memories. John and Jane were inseparable.",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 8,
                text: "I always admired their bond; they truly supported each other through everything.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "They didn't just grow old together, they grew stronger.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "This hug is worth a thousand words-a testament to a lifetime together.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John and Jane's embrace says it all. They were each other's world.",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "They had a love that was built on friendship and deep respect.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "It's incredible to see such a pure, enduring love.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "A hug filled with love, wisdom, and countless shared memories. John and Jane were one of a kind.",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 14,
                text: "I remember them telling stories from their early days-they were inseparable even then.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "They found joy in the simplest things, just being with each other.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "Their love gave so much hope to everyone around them.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Even in their later years, John and Jane's love was as strong as ever. This hug says it all.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 9,
                text: "Every time I saw them together, they had that same spark.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "This is what forever love looks like-John and Jane, together through it all.",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 13,
                text: "They faced life hand-in-hand, always with love and strength.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "A lifetime of laughter, love, and support in one hug. John and Jane were made for each other.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "John and Jane in a perfect embrace-a love story that lasted a lifetime.",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "Even after all these years, they still looked at each other with such admiration.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Seeing John and Jane like this is a reminder of the power of true love. They were each other's everything.",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "John and Jane, wrapped in each other's arms-a love that defied time.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 21,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done grave
      {
        description:
          "John was a loving husband, father, and friend. He will be deeply missed by all who knew him.",
        memoryDate: "2023-12-07T00:00:00",
        title: "John's funeral",
        imageUrl: require("@/assets/images/demo/timelines/passed-away-3-min.png"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text: "Such a beautiful tribute to John. His memory will forever live on in the hearts of everyone who knew him.",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 18,
                text:
                  "Absolutely, John was one of those rare people who made a lasting impact on everyone he encountered.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "It's so true, his kindness and generosity touched us all in ways we'll never forget.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text:
              "This is a poignant moment. John touched so many lives, and it's evident by the love shown here.",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 2,
                text:
                  "You can see just how many people he impacted. He had a big heart and it showed.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "John always made time for others, no matter how busy he was. That's the kind of person he was.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text:
                  "The way people came together today is proof of how deeply he affected all of us.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "What a heartfelt farewell. John's kindness and warmth will be deeply missed by all.",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "He was one of the kindest souls I ever met. His warmth was infectious.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text:
                  "I'll always remember how he made everyone feel like they mattered. That was John's gift",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "This image captures the love and support of family and friends coming together to honor John's life.",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 21,
                text:
                  "It's comforting to see everyone here supporting each other, just as John would have wanted.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "John always valued his friendships and family more than anything. This gathering reflects that.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text:
                  "We're all here because of the love he gave us. It's a fitting way to honor his memory.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "Such a bittersweet moment. John's legacy of love and laughter will carry on through all of us.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text:
                  "Even in this sadness, we can remember all the joy he brought into our lives.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "Look at all the people who came to pay their respects. John truly made an impact on everyone he met.",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 18,
                text:
                  "The turnout today says everything about the person John was. He touched so many hearts.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "He never hesitated to help others, and that kindness is why we're all here today.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "What a powerful testament to John's life. He brought joy and light to so many and will be remembered fondly.",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text:
                  "John's ability to bring joy to others is something we'll all carry with us.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "This is a touching farewell. John's spirit will continue to inspire us, even though he's no longer with us.",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "This photo reflects the deep bond shared by all who loved John. His memory will always be cherished.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 11,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      }
    ];
  },
};
